<template>
    <div class="form-group text">
        <label
            class="control-label"
            :for="name"
            v-text="label"
        ></label>
        <select
            class="form-control"
            :id="name"
            :name="name"
            v-model="country"
        >
            <option
                :key="country"
                :value="country"
                v-for="country in countries"
                v-text="country"
            ></option>
        </select>
    </div>
</template>

<script>
import {CountryData} from "../../../../config";

export default {
    name: 'CountryInput',

    props: {
        label: {
            default: 'Country',
            required: false,
            type: String,
        },
        name: {
            default: 'country',
            required: false,
            type: String,
        },
        value: {
            default: CountryData.GBR.name,
            required: false,
            type: String,
        },
    },

    data() {
        return {
            countries: Object.values(CountryData).map(value => value.name).sort(),
            country: this.value,
        }
    },

    watch: {
        country(newVal) {
            this.$emit('input', newVal);
        },
        value(newVal) {
            Object.assign(this, {country: newVal});
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Utility/Forms/InputFields/CountryInput.vue